import { Command } from '@nest/internal-frontend';
import { Skeleton } from '@nest/uikit-react';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam } from '../helpers';
import { useCommandOpenPackedNotInContainerListPage } from './consignment-notes/commands/consignment-notes-open-packed-not-in-container.command';
import { useCommandGoToCompletedConsignmentNotes } from './consignment-notes/commands/go-to-completed-consignment-notes.command';
import { useCommandGoToNewConsignmentNote } from './consignment-notes/commands/go-to-new-consignment-note.command';

export default function ConsignmentNotesListPage() {
	const client = useTerminalClient();
	const navigate = useNavigate();
	const carrierId = useNumberParam('carrierId');

	const carrierQuery = useQuery({
		queryKey: ['carrier', carrierId],
		queryFn: () => client.carriers.getById.execute({ id: carrierId! }),
		enabled: !!carrierId
	});

	const listQuery = useInfiniteQuery({
		queryKey: ['consignment-notes-list'],
		queryFn: ({ pageParam }) => client.consignmentNotes.getConsignmentNotesQuery.execute({ offset: pageParam, limit: 10, carrierId: carrierId! }),
		getNextPageParam: (lastPage, allPages) => (lastPage.length === 10 ? allPages.length * 10 : undefined),
		initialPageParam: 0,
		enabled: !!carrierQuery.data
	});

	const commands: Command[] = [useCommandGoToNewConsignmentNote(), useCommandGoToCompletedConsignmentNotes(), useCommandOpenPackedNotInContainerListPage()];

	const list = useMemo(() => listQuery.data?.pages.flatMap(p => p) ?? [], [listQuery.data]);

	return (
		<TerminalScreen showBackButton topBar={<div>{carrierQuery.data?.name}</div>} commands={commands}>
			<div className="p-2 flex flex-col gap-2">
				{carrierQuery.isLoading || listQuery.isLoading ? (
					<div className="space-y-2">
						<Skeleton className="h-10 w-full" />
						<Skeleton className="h-10 w-full" />
					</div>
				) : (
					<>
						{list.map(item => (
							<button
								key={item.id}
								className="w-full text-left border rounded p-2 hover:bg-muted/50"
								onClick={() => navigate(`/consignment-notes/carriers/${carrierId}/list/${item.id}`)}
							>
								<div className="font-medium">{item.containerNumber}</div>
								<div className="text-xs text-muted-foreground">{item.carrier?.name ?? ''}</div>
							</button>
						))}
						{list.length === 0 && <div className="p-6 text-center text-muted-foreground">Žádné záznamy</div>}
					</>
				)}
			</div>
		</TerminalScreen>
	);
}
